import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { StorageType, useList } from '@ztechapps/common.hook'
import { logisticListQueries } from './graphql'
import type { Logistic } from '@ztechapps/common.contract'
import merge from 'lodash/merge'

export const useLogisticList = ({ query, ...restProps } = {} as UseListProps): UseListResult<Logistic> => {
  query = query ?? logisticListQueries.allConfig.query

  const defaultConfig: UseListProps = {
    query,
    limit: 100,
    sort: { createdAt: -1 },
    listActionOptions: {
      storageType: StorageType.localStorage,
    },
  }

  const mergedConfig = merge(defaultConfig, restProps)

  return useList<Logistic>(mergedConfig)
}
